var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"backSnow overflow-hidden",style:({height:_vm.height+'px'}),attrs:{"color":_vm.$mainColor}},[_c('canvas',{ref:"snow",staticStyle:{"opacity":"0.5"},style:({height:_vm.height+'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }